import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=0a8d3eca&scoped=true&"
import script from "./Market.vue?vue&type=script&lang=js&"
export * from "./Market.vue?vue&type=script&lang=js&"
import style0 from "./Market.vue?vue&type=style&index=0&id=0a8d3eca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d3eca",
  null
  
)

export default component.exports